import { AttributeColumnRenderer } from '@leverege/ui-attributes';
export default class ObjectAttributeColumnRenderer extends AttributeColumnRenderer {
  constructor(...args) {
    super(...args);
    this.superRenderCell = this.renderCell;
    this.renderCell = this.realRenderCell;
  }
  realRenderCell = data => {
    const {
      value
    } = data;
    let str;
    if (typeof value === 'object' && value != null) {
      try {
        str = JSON.stringify(value);
      } catch (err) {
        // do nothing?
      }
    } else {
      str = value;
    }
    return this.superRenderCell({
      ...data,
      value: str
    });
  };
}